import { columnType } from 'components/table/types';
import type { MouseEvent } from 'react';
import _ from 'lodash';
import {
	SystemMessageAudienceLabelKey,
	SystemMessageIconLabelKey,
	type SystemMessageAudienceType,
	type SystemMessageIconType,
} from 'constants/system-messages.constants';
import { SystemMessageStatusSwitch } from './components/SystemMessageStatusSwitch';
import { SYSTEM_MESSAGES_SORTABLE_COLUMNS } from 'constants/system-messages.constants';
import { systemMessagesTableTypes, tableColumns } from './tables.types';

const columnTitleKeys: Record<string, string> = {
	internalDescription: 'page.systemMessages.table.column.internalDescription',
	createdAt: 'page.pendingRequests.field.createdAt',
	createdBy: 'page.systemMessages.table.column.createdBy',
	iconType: 'label.type',
	audienceType: 'page.systemMessages.table.column.audience',
	startDate: 'page.systemMessages.table.column.startDate',
	endDate: 'page.systemMessages.table.column.endDate',
	confirmedCount: 'page.systemMessages.table.column.confirmedCount',
	isLive: 'page.pendingRequests.field.status',
};

const stopStatusColumnRowClick = (event: MouseEvent<HTMLElement>) => {
	event.stopPropagation();
};

export const tableData = (data: Record<string, any>[]) => {
	return data.map((item) => ({
		...item,
		createdBy: item?.createdBy?.displayName ?? '',
		confirmedCount: item.confirmedCount ?? 0,
	}));
};

export const buildColumns = (type: systemMessagesTableTypes, t: any): columnType[] => {
	const columns: columnType[] = [];
	if (!_.has(tableColumns, type)) {
		return columns;
	}

	_.keys(tableColumns[type]).forEach((element) => {
		let customValueHandle = {};

		if (element === 'iconType') {
			customValueHandle = {
				customValueHandle: (value: string) =>
					t(SystemMessageIconLabelKey[value as SystemMessageIconType]),
			};
		}
		if (element === 'audienceType') {
			customValueHandle = {
				customValueHandle: (value: string) =>
					t(SystemMessageAudienceLabelKey[value as SystemMessageAudienceType]),
			};
		}
		if (element === 'isLive') {
			const isCompanyTable = type === systemMessagesTableTypes.COMPANY;
			customValueHandle = {
				eventsHandle: {
					onClick: stopStatusColumnRowClick,
					onMouseDown: stopStatusColumnRowClick,
				},
				customValueHandle: (_value: boolean, row: Record<string, any>) => (
					<SystemMessageStatusSwitch
						messageId={row.id}
						isLive={row.isLive}
						readOnly={isCompanyTable}
					/>
				),
			};
		}

		const props: columnType = {
			name: element,
			title: t(columnTitleKeys[element]),
			type: _.get(tableColumns[type], element),
			fieldId: element,
			sortable: SYSTEM_MESSAGES_SORTABLE_COLUMNS.has(element),
			...customValueHandle,
		};
		columns.push(props);
	});

	return columns;
};
